/* tslint:disable:max-line-length */
import React from 'react';
import { IconTypeProps } from '../types';
import classNames from 'classnames';

export const RefreshArrowIcon = ({
  className,
  style,
  color = '#262626',
  onClick,
}: IconTypeProps) => {
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      style={style}
      width="20"
      height="20"
      fill="none"
    >
      <path
        fill={color}
        d="M6.241 5.514c.889-.71 1.968-1.274 3.27-1.274a5.6 5.6 0 1 1-5.275 7.485c-.139-.388-.53-.649-.934-.563l-.73.155c-.404.085-.665.483-.541.877A7.84 7.84 0 1 0 9.51 2c-2.079 0-3.697.947-4.862 1.922l-1.33-1.33a.747.747 0 0 0-1.275.528v4.106c0 .413.335.747.747.747h4.106a.747.747 0 0 0 .528-1.275L6.241 5.514Z"
      />
    </svg>
  );
};
